import { render, staticRenderFns } from "./reGoodsDetail.vue?vue&type=template&id=a89f730a&scoped=true"
import script from "./reGoodsDetail.vue?vue&type=script&lang=js"
export * from "./reGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./reGoodsDetail.vue?vue&type=style&index=0&id=a89f730a&prod&lang=scss&scoped=true"
import style1 from "./reGoodsDetail.vue?vue&type=style&index=1&id=a89f730a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f730a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoodsZoom: require('/drone/src/components/GoodsZoom/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,GoodsIntroduce: require('/drone/src/components/GoodsDesc/GoodsIntroduce.vue').default})
